/**
 * Ürün vitrini (backend yok — buradan yönetilir).
 *
 * 1) Görselleri şu klasöre koyun: public/images/products/
 *    Örnek dosya: public/images/products/davetiyeler/dugun/klasik-zarif.jpg
 * 2) Aşağıda ilgili diziye bir nesne ekleyin; `image` yolunu /images/... ile başlatın.
 *
 * Alanlar:
 * - id: benzersiz string
 * - name: ürün adı
 * - hint: kısa açıklama (isteğe bağlı)
 * - image: public köküne göre yol (isteğe bağlı; yoksa veya dosya yoksa yer tutucu)
 * - price: sayı, TL (priceOnRequest true ise yok sayılır)
 * - priceOnRequest: true ise "Teklif üzerine" gösterilir
 * - priceNote: fiyat altı not, örn. "100 adet için"
 */

export function formatTryPrice(amount) {
  if (amount == null || Number.isNaN(Number(amount))) return '';
  return new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: 'TRY',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(Number(amount));
}

export function productPriceLabel(product) {
  if (product.priceOnRequest) return 'Teklif üzerine';
  if (typeof product.price === 'string' && product.price.trim()) {
    return product.price.trim();
  }
  if (product.price != null && product.price !== '') {
    const n = Number(product.price);
    if (!Number.isNaN(n)) return formatTryPrice(n);
  }
  return '';
}

/**
 * @param {'davetiyeler' | 'sekerlik'} hub
 * @param {string} categorySlug
 * @param {string} productId
 */
export function getProductById(hub, categorySlug, productId) {
  const list = getProductsForCategory(hub, categorySlug);
  return list.find((p) => p.id === productId) ?? null;
}

export const productsByCategory = {
  davetiyeler: {
    dugun: [
      {
        id: 'dv-dugun-1',
        name: 'Klasik zarif',
        hint: 'Altın detay, mat kağıt',
        image: '/images/products/davetiyeler/dugun/klasik-zarif.jpg',
        price: 450,
        priceNote: '100 adet için',
      },
      {
        id: 'dv-dugun-2',
        name: 'Minimal şık',
        hint: 'Beyaz zemin, sade tipografi',
        image: '/images/products/davetiyeler/dugun/davetiye1.png',
        price: 400,
        priceNote: '100 adet için',
      },
      {
        id: 'dv-dugun-3',
        name: 'Erdem 5148',
        hint: '',
        image: '/images/products/davetiyeler/dugun/davetiye2.png',
        price: 2663,
        priceNote: '100 adet için',
      },
      {
        id: 'dv-dugun-4',
        name: 'Erdem 5141',
        hint: 'Siyah zemin, altın yaldız',
        image: '/images/products/davetiyeler/dugun/davetiye3.png',
        price: 2532,
        priceNote: '100 adet için',
      },
      {
        id: 'dv-dugun-5',
        name: 'Erdem 5149',
        hint: '',
        image: '/images/products/davetiyeler/dugun/davetiye4.png',
        price: 2531,
        priceNote: '100 adet için',
      },
      {
        id: 'dv-dugun-6',
        name: 'Erdem 5125',
        hint: '',
        image: '/images/products/davetiyeler/dugun/davetiye5.png',
        price: 2563,
        priceNote: '100 adet için',
      },
      {
        id: 'dv-dugun-14',
        name: 'Erdem 5149',
        hint: '',
        image: '/images/products/davetiyeler/dugun/davetiye6.png',
        price: 2531,
        priceNote: '100 adet için',
      },
      {
        id: 'dv-dugun-7',
        name: 'Bohem stil',
        hint: 'Doğal tonlar, özgür tasarım',
        image: '/images/products/davetiyeler/dugun/davetiye7.png',
        price: 425,
        priceNote: '100 adet için',
      },
      {
        id: 'dv-dugun-8',
        name: 'Lüks kabartmalı',
        hint: 'Kabartma yazı, kalın karton',
        image: '/images/products/davetiyeler/dugun/davetiye8.png',
        price: 520,
        priceNote: '100 adet için',
      },
      {
        id: 'dv-dugun-9',
        name: 'Soft pastel',
        hint: 'Açık renk paleti, zarif çizgiler',
        image: '/images/products/davetiyeler/dugun/davetiye9.png',
        price: 405,
        priceNote: '100 adet için',
      },
      {
        id: 'dv-dugun-10',
        name: 'Geometrik modern',
        hint: 'Keskin hatlar, modern desen',
        image: '/images/products/davetiyeler/dugun/davetiye10.png',
        price: 440,
        priceNote: '100 adet için',
      },
      {
        id: 'dv-dugun-11',
        name: 'Şeffaf detaylı',
        hint: 'Asetat kaplama, minimal içerik',
        image: '/images/products/davetiyeler/dugun/davetiye11.png',
        price: 530,
        priceNote: '100 adet için',
      },
      {
        id: 'dv-dugun-12',
        name: 'Klasik beyaz',
        hint: 'Temiz tasarım, siyah yazı',
        image: '/images/products/davetiyeler/dugun/davetiye12.png',
        price: 390,
        priceNote: '100 adet için',
      },
      {
        id: 'dv-dugun-13',
        name: 'Altın varaklı',
        hint: 'Parlak detaylar, lüks görünüm',
        image: '/images/products/davetiyeler/dugun/davetiye13.png',
        price: 550,
        priceNote: '100 adet için',
      }
    ],
    sunnet: [],
    nisan: [],
  },
  sekerlik: {
    dugun: [],
    nisan: [],
    sunnet: [],
    dogum: [],
  },
};

/**
 * @param {'davetiyeler' | 'sekerlik'} hub
 * @param {string} categorySlug
 */
export function getProductsForCategory(hub, categorySlug) {
  const hubMap = productsByCategory[hub];
  if (!hubMap) return [];
  const list = hubMap[categorySlug];
  return Array.isArray(list) ? list : [];
}
